<template>
  <transition name="search-slide">
    <div class="sceneSearch">
      <div class="sceneSearch__close" @click.prevent="goBack">
        <img src="/assets/img/svg/close.svg" alt=""/>
      </div>
      <div class="sceneSearch__tabs">
        <div v-for="tab in tabs"
             class="sceneSearch__tabs__item"
             @click="toggleTab(tab)"
             :data-active="isActive(tab)">
          <h3>{{tab.title}}</h3>
          <span>{{tab.caption}}</span>
        </div>
      </div>
      <div class="sceneSearch__fields">
        <div class="sceneSearch__input" v-show="tabs[0].isActive">
          <input id="product-search-input"
                 type="text"
                 autocomplete="off"
                 title="Search product"
                 :placeholder="placeholder"
                 @keydown.enter="autoCompleteProducts"/>
          <button @click="autoCompleteProducts">
            <img src="https://placehold.it/30x30" alt=""/>
          </button>
        </div>
        <div class="sceneSearch__alphabetical" v-show="tabs[1].isActive">
          <div class="sceneSearch__alphabet">
            <div v-for="letter in alphabet"
                 class="sceneSearch__letter"
                 @click="displayResults(letter)">
              {{letter}}
            </div>
          </div>
        </div>
      </div>
      <div class="sceneSearch__content">
        <div class="sceneSearch__content__outer">
          <div class="sceneSearch__content__wrapper">
            <div class="sceneSearch__content__slider">
              <transition-group name="searchProduct">
                <div :key="result.product" class="sceneSearch__content__item" v-for="(result, index) in results"
                     :style="addDelay(index)">
                  <img :src="result.image" :alt="result.name"/>
                  <h4>{{result.name}}</h4>
                  <p>{{result.info}}</p>
                  <div>
                    <a href="#">{{productConfigure}}</a>
                  </div>
                </div>
              </transition-group>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
  var timer = 0;
  var slider;
  var timeout = 0;
  var prevValue = '';

  export default{
    data(){
      return {
        tabs: [
          {
            name: 'manual',
            title: 'Search Products',
            caption: 'Search for products by keyword or product code.',
            isActive: true
          },
          {
            name: 'list',
            title: 'View Product List',
            caption: 'Search for products by alphabetical order.',
            isActive: false
          }
        ],
        placeholder: '',
        productConfigure: '',
        items: [],
        alphabet: [
          'A',
          'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'
        ],
        results: [],
        timer: 0
      }
    },
    methods: {
      goBack(){
        this.results = [];
        this.$store.state.interface.isSearchVisible = false;
      },
      toggleTab(tab){
        var that = this;
        if (!tab.isActive) {
          timeout = 0;
          that.results = [];
          that.$nextTick()
            .then(function () {
              if (slider) {
                slider.destroy();
                slider = '';
                document.querySelector('.sceneSearch__content__slider').innerHTML = '';
              }
              document.querySelector('#product-search-input').value = '';
              var letters = document.querySelectorAll('.sceneSearch__letter');
              for (var i = 0; i < letters.length; i++) {
                letters[i].removeAttribute('data-active');
              }
              that.$nextTick(function () {
                for (var i = 0; i < this.tabs.length; i++) {
                  that.tabs[i].isActive = false;
                }
                tab.isActive = true;
              })
            })
        }
      },
      isActive(tab){
        return tab.isActive;
      },
      addDelay(idx){
        return 'transition-delay: ' + (idx * 25) + 'ms;';
      },
      delayAutoComplete(){
        var input = document.querySelector('#product-search-input');
        var value = input.value;
        var that = this;

        clearInterval(timer);
        if (value.length) {
          timer = setTimeout(function () {
            that.autoCompleteProducts();
          }, 1000);
        }
      },
      autoCompleteProducts(){
        var input = document.querySelector('#product-search-input');
        var value = input.value;
        var that = this;

        if (value.length > 3 && value != prevValue) {
          that.results = [];
          that.$nextTick()
            .then(function () {
              setTimeout(function () {
                for (var i = 0; i < that.items.length; i++) {
                  var el = that.items[i];
                  if (el.name.toUpperCase().indexOf(value.toUpperCase()) !== -1 ||
                    el.product == value) {
                    that.results.push(el);
                  }
                }
                prevValue = value;
              }, timeout)
            })
            .then(function () {
              timeout = 500;
            })
        }
      },
      checkPresentLetters(){
        var that = this;
        var divs = document.querySelectorAll('.sceneSearch__letter');
        for (var i = 0; i < that.items.length; i++) {
          var el = that.items[i].name;
          var letter = el.charAt(0).toUpperCase();
          var idx = that.alphabet.indexOf(letter);
          if (!divs[idx].getAttribute('data-present')) {
            divs[idx].setAttribute('data-present', true);
          }
        }
      },
      displayResults(letter){
        var that = this;
        var idx = that.alphabet.indexOf(letter);
        var divs = document.querySelectorAll('.sceneSearch__letter');
        if (divs[idx].getAttribute('data-present')) {
          if (!divs[idx].getAttribute('data-active')) {
            that.results = [];
            that.$nextTick()
              .then(function () {
                setTimeout(function () {
                  for (var i = 0; i < that.items.length; i++) {
                    if (that.items[i].name.charAt(0).toUpperCase() == letter) {
                      that.results.push(that.items[i]);
                    }
                  }
                  for (i = 0; i < divs.length; i++) {
                    divs[i].removeAttribute('data-active');
                  }
                  divs[idx].setAttribute('data-active', true);
                }, timeout);
              })
              .then(function () {
                timeout = 500;
              })
          }
        }
      }
    },
    created(){
      var url = document.querySelector('#root').getAttribute('data-endpoint-products');
      var vm = this;
      vm.tabs[0].title = vm.$store.state.labels.search.autocompleteHeader;
      vm.tabs[0].caption = vm.$store.state.labels.search.autocompleteDescription;
      vm.tabs[1].title = vm.$store.state.labels.search.selectHeader;
      vm.tabs[1].caption = vm.$store.state.labels.search.selectDescription;
      vm.placeholder = vm.$store.state.labels.search.autocompletePlaceholder;
      vm.productConfigure = vm.$store.state.labels.search.selectCta;

      fetch(url)
        .then(function (response) {
          return response.json();
        })
        .catch(function () {
          vm.$router.push('/');
        })
        .then(function (data) {
          if (data.header.success) {
            for (var i = 0; i < data.data.length; i++) {
              vm.items.push(data.data[i]);
            }
            vm.checkPresentLetters();
          }
          else {
            vm.$router.push('/');
          }
        });
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/SceneSearch.vue